import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeI18TableItem } from 'dash-front/common-i18-dashboard-page/actions';
import TextField from 'material-ui/TextField';

class CommonI18TableRowColumnInput extends Component {
    state = {
        value: this.props.value || '',
    };

    componentWillReceiveProps({ value = '' }) {
        if (value !== this.state.value) {
            this.setState({ value });
        }
    }

    handleChange = (ev, value) => {
        ev.preventDefault();
        this.props.changeI18TableItem(this.props.lang, this.props.label, value);
        this.setState({ value });
    };

    render() {
        return (
            <TextField
                fullWidth
                type="text"
                name={this.state.value}
                value={this.state.value}
                hintText=" "
                onChange={this.handleChange}
            />
        );
    }
}

CommonI18TableRowColumnInput.propTypes = {
    lang: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    // From Connect
    value: PropTypes.string,
    changeI18TableItem: PropTypes.func.isRequired,
};

export default connect(
    ({ commonI18Dashboard: { i18, secondaryLanguage } }, { lang, label }) => {
        lang = lang === 'secondary' ? secondaryLanguage : lang;

        return {
            value: i18[lang] && i18[lang][label],
        };
    },
    { changeI18TableItem },
)(CommonI18TableRowColumnInput);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/CommonI18TableRowColumnInput.js
 **/